import React from "react";
import "./styles/routeSpinner.scss";

const RouteSpinner = () => {
    return <div className="route-spinner">Loading...</div>;
};

export default RouteSpinner;
